// extracted by mini-css-extract-plugin
export default {"container":"u1-z","list":"v1-z"};